<!-- <summary>
      Activity Points Update Screen
     </summary>
     <history>
        [naziya] 11/29/24 2956: Created.
        [naziya] 12/4/24 2956: Committed.
     </history>  -->

     <app-header navScreen="Home" class="mb-5"></app-header>
     <ng-container *ngComponentOutlet="LoaderComponent">
     </ng-container>
     
     <div class="container">
        <div class="border p-2 ka-searchEmp-main mb-2">
          <div class="table-container">
            
       <div class="table-half">
        <h2>  Activity Points  </h2>
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 normal-table">
      
          <!-- Activity Column -->
          <ng-container matColumnDef="activity">
            <td mat-cell *matCellDef="let activity">{{ activity.ActivityName }}</td>
          </ng-container>
      
          <!-- Points Column -->
          <ng-container matColumnDef="points">
            <td mat-cell *matCellDef="let activity">
              <input type="number" [(ngModel)]="activity.Points"  class="points-input" maxlength="3" min="0" max="999"
               (keypress)="restrictInput($event)" [disabled]="!isEditModeActivity[activity.ActivityID]"/>
              <button mat-button class="ka-emp-addMasterData" (click)="toggleEditMode(activity, 'Activity')">
                {{ isEditModeActivity[activity.ActivityID] ? 'Save' : 'Update' }}
              </button>
            </td>
          </ng-container>
      
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      
        </table>
      </div>
       
       <div class="table-half">
        <h2> Sub Activity (Data Details Edit/Add) Points </h2>
        <table mat-table [dataSource]="dataSource1" class="mat-elevation-z8 normal-table">
      
          <!-- Activity Column -->
          <ng-container matColumnDef="activity">
            <td mat-cell *matCellDef="let activity1">{{ activity1.SubActivityName }}</td>
          </ng-container>
      
          <!-- Points Column -->
          <ng-container matColumnDef="points">
            <td mat-cell *matCellDef="let activity1">
              <input type="number" [(ngModel)]="activity1.Points" class="points-input" maxlength="3" min="0" max="999"
               (keypress)="restrictInput($event)" [disabled]="!isEditModeSubActivity[activity1.SubActivityID]"/>
              <button mat-button class="ka-emp-addMasterData" (click)="toggleEditMode(activity1, 'subActivity')">
                {{ isEditModeSubActivity[activity1.SubActivityID] ? 'Save' : 'Update' }}
              </button>
            </td>
          </ng-container>
          
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      
        </table>
      </div>
       
     
       <div mdbModal #alertModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel" aria-hidden="true"
       [config]="{ backdrop: true, ignoreBackdropClick: true, keyboard: false }">
      <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="alertModal.hide()">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="row text-left">
              <div class="col-md-12 rmSectionPopup">
                <div class="row p-2 m-2">
                  <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
                    <p class="mt-2 p-0">{{responseMessage}}</p>
                    <div class="action-buttons">
                      <button mdbBtn class="ka-white-button tButton ka-btn-primary btn-success btn mb-3 mt-2" mdbWavesEffect
                              type="submit" (click)="alertModal.hide()">OK
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
     </div>
